var wrapper = require('./wrapper');

module.exports = function (name, obj) {
  var f = { value : obj, constant : true };
  this.$$factories[name] = f;
  return wrapper(f).lifecycle.application();
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/jpex/src/factories/constant.js
// module id = vNsD
// module chunks = 0